import { render, staticRenderFns } from "./RoomMenu_comp.vue?vue&type=template&id=62935835&scoped=true&"
import script from "./RoomMenu_comp.vue?vue&type=script&lang=js&"
export * from "./RoomMenu_comp.vue?vue&type=script&lang=js&"
import style0 from "./RoomMenu_comp.vue?vue&type=style&index=0&id=62935835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62935835",
  null
  
)

export default component.exports